/**
 * Scroll
 * @class
 */
class Scroll {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      animeOpts: {
        duration: 600,
        easing  : 'easeOutQuad',
        offset  : 0,
      },
    }
  };

  /**
   * @instance
   * @param el {HTMLElement} trigger element
   * @param opts {object} options
   */
  constructor(el = null, opts = {}) {
    const { animeOpts } = _.defaultsDeep(opts, Scroll.defOpts);

    this.el        = el;
    this.animeOpts = animeOpts;

    this.events = {
      beforeScroll: new CustomEvent('beforeScroll.anchor'),
      afterScroll : new CustomEvent('beforeScroll.anchor'),
    };
  }

  /**
   * @instance
   * @param el {HTMLElement} target element
   */
  run(el) {
    Velocity(el, 'stop');
    Velocity(el, 'scroll', _.merge(this.animeOpts, {
      begin: () => {
        if(!this.el) return;
        this.el.dispatchEvent(this.events.beforeScroll);
      },
      complete: () => {
        if(this.el) return;
        this.el.dispatchEvent(this.events.afterScroll);
      },
    }));
  }

}

/**
 * class exports
 */
module.exports = Scroll;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/scroll.js
 **/